import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Heart, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function OurStory() {
  return (
    <div className="min-h-screen bg-[#FBF7F2]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <p className="section-eyebrow text-center">Our story</p>
          <h1 className="font-serif text-4xl lg:text-6xl text-center mt-3 text-[#2A2A2A] leading-tight">
            Built by couples who actually <span className="italic text-[#7B2C3B]">got married</span>.
          </h1>
          <div className="flex justify-center mt-8 mb-12"><div className="divider-leaf" /></div>

          <div className="prose-content space-y-6 text-[#3A3A3A] leading-relaxed text-lg">
            <p>
              Yourweddingfriends started the way most great wedding ideas do: at 1am, three months out, surrounded by sticky notes and lukewarm tea, with the quiet realization that nothing we had — not the apps, not the binders, not the well-meaning aunt with her clipboard — was actually helping.
            </p>
            <p>
              We didn’t need more checklists. We needed one calm place where the budget, the guest list, the vendors, the seating chart and the timeline all talked to each other. We needed a friend who knew weddings, who didn’t mind being asked the same question at midnight, and who didn’t charge $2,000 an hour.
            </p>
            <p>
              So we built that. Then we got married. Then we built it again, better, after we noticed the parts that almost broke us.
            </p>
            <p>
              What you’re using today is the planner we wish we’d had — quiet, kind, smart, and honestly pretty. It’s used by couples around the world, and it gets better every month based on what they tell us.
            </p>
          </div>

          <div className="mt-14 soft-card rounded-3xl p-8 text-center">
            <Sparkles className="w-7 h-7 text-[#7B2C3B] mx-auto mb-3" />
            <h3 className="font-serif text-2xl text-[#2A2A2A] mb-2">A small team. A big idea.</h3>
            <p className="text-[#4A4A4A]">We’re a five-person team of designers, engineers and a former wedding planner who saw too many couples cry over color-coded spreadsheets. We’re here to fix that.</p>
          </div>

          <div className="text-center mt-12">
            <Link to="/#pricing" className="btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium">
              <Heart className="w-4 h-4 fill-current" /> Start planning with us
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
